import * as contractingSelectors from '@makemydeal/dr-dash-store/selectors/contractingSelectors';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { useSelector } from 'react-redux';
import { ContractStatusBadge } from './ContractStatusBadge';

export type ContractStatusBadgeContainerProps = {
    onShowErrors?: () => void;
};

export const ContractStatusBadgeContainer = () => {
    const contractingStatusInfo = useSelector(contractingSelectors.getContractingStatusInfo);
    const hasContractingStatusFailure = useSelector(contractingSelectors.hasContractingStatusFailure);
    const isDisplayContractStatusEnabled = useSelector(featureToggleSelectors.isDisplayContractStatusEnabled);

    if (!isDisplayContractStatusEnabled || !contractingStatusInfo?.contractStatusCode || hasContractingStatusFailure) {
        return null;
    }

    return <ContractStatusBadge contractingStatusInfo={contractingStatusInfo} />;
};
